import React, { useState } from 'react';
import flower from '../images/flower.png';
import { FaMoneyCheck } from 'react-icons/fa6';
import Modal from '../components/Modal';
import '../css/Modal.css';
import { GROOM_ACCOUNT_CONTACTS, BRIDE_ACCOUNT_CONTACTS } from '../constants/wedding';

function ContactButton({ person, account }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="contact__box">
        <span>{person}</span>
        <div className="contact__icons">
          <button onClick={openModal} className="contact__btn"><FaMoneyCheck size="1.5em"/></button>
        </div>
      </div>
      {isModalOpen && (
        <Modal closeModal={closeModal} who={person} account={account}/>
      )}
    </>
  );
}

function Account() {
  return (
    <div className="container bc-alt">
      <img src={flower} className="flower" alt="flower"/>
      <div className='contact__title'>마음 전하는 곳</div>
      <div className="contact__boxes">
        {GROOM_ACCOUNT_CONTACTS.map((contact, index) => (
          <ContactButton key={index} person={contact.person} account={contact.account}/>
        ))}
      </div>
      <div className="contact__boxes">
        {BRIDE_ACCOUNT_CONTACTS.map((contact, index) => (
          <ContactButton key={index} person={contact.person} account={contact.account}/>
        ))}
      </div>
      <div className="contact__guide-text">아이콘을 클릭하시면 계좌번호를 확인할 수 있습니다.</div>
    </div>
  );
}

export default Account;
